// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrencyInput_wrapper__Tm9Gh","input":"CurrencyInput_input__NJPxt","currencySymbol":"CurrencyInput_currencySymbol__pSfgt"};